module.exports = __webpack_public_path__ + "img/96.5ff53a50.jpg";